// src/utils/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('access_token'); // or use Redux/store

  return isAuthenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
